import CallHistoryItem from "./CallHistoryItem";

const CallHistory = ({clickHandler, clickAllowed, history = [], callUuid}) => {
    const itemClickHandler = (index) => () => clickHandler(index);

    return <div className="flex flex-row overflow-y-auto max-h-50 bg-slate-200">
        {history.map((data,index) => <CallHistoryItem clickAllowed={clickAllowed}
                                                      clickHandler={itemClickHandler(index)}
                                                      history={data}
                                                      key={callUuid + "_call_history_" + index}/> )}
    </div>
};
export default CallHistory;
